export default {
    url: '/general',
    // a save refused on another tab for the group's sites or people is brought here with its errors,
    // this is the only tab where either can be changed
    params: {
        saveErrors: null
    },
    template: `
        <courses-courses-edit-occurrence-automated-planning-group-edit-general
            planning-group="vm.planningGroup"
            sites="vm.sites"
            course-versions="vm.courseVersions"
            save-errors="vm.saveErrors"
        />
    `,
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ planningGroupSites: true }).$promise;
        },
        courseVersions (CourseVersionResource, $stateParams) {
            return CourseVersionResource.query({
                courseId: $stateParams.id,
                isPlanningGroupSearch: true,
                planningGroupId: $stateParams.planningGroupId
            }).$promise;
        }
    },
    controller ($scope, $stateParams, sites, courseVersions) {
        $scope.$parent.vm.step = 1;
        this.planningGroup = $scope.$parent.vm.planningGroup;
        this.sites = sites;
        this.courseVersions = courseVersions;
        // read only: Transition.params() is frozen, so this object must never be written to
        this.saveErrors = $stateParams.saveErrors;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/edit/general/index.js